import React from 'react'

import Component from './component'

const JobInfoContainer = (props) => {

  const mergedProps = {
  }

  return (
    <Component {...mergedProps} />
  )
}

export default JobInfoContainer
